import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import type { ColumnData, ItemData } from './KanbanBoard';
import { KanbanItem } from './KanbanItem';

interface KanbanColumnProps {
  column: ColumnData;
  items: ItemData[];
}

export function KanbanColumn({ column, items }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: column.id,
    data: {
      type: 'Column',
      column,
    },
  });

  return (
    <div
      ref={setNodeRef}
      className={`flex flex-col flex-shrink-0 w-80 bg-muted/40 dark:bg-zinc-900/50 border border-border/50 rounded-xl overflow-hidden h-full transition-all duration-150 ${
        isOver ? 'ring-2 ring-primary/40 bg-primary/5 dark:bg-primary/10' : ''
      }`}
    >
      <div className="p-3.5 font-semibold text-gray-700 dark:text-gray-300 border-b border-border/40 bg-background/50 backdrop-blur-sm">
        {column.title}
      </div>
      <div className="flex-1 p-3 overflow-y-auto min-h-[160px] flex flex-col gap-2.5 scrollbar-thin">
        <SortableContext
          id={String(column.id)}
          items={items.map((item) => item.id)}
          strategy={verticalListSortingStrategy}
        >
          {items.map((item) => (
            <KanbanItem key={item.id} item={item} />
          ))}
        </SortableContext>
        {items.length === 0 && (
          <div className="flex-1 min-h-[100px] flex items-center justify-center border-2 border-dashed border-border/40 rounded-xl p-4 text-xs text-muted-foreground/60 select-none">
            No tasks
          </div>
        )}
      </div>
    </div>
  );
}
